import { useEffect, useState } from 'react'
import { AnalyticsNamespace, WebPhoneAnalyticsEvents } from '~/types/Analytics'

import { useAnalytics } from './useAnalytics'
import useCloudwatchLogger from './useCloudwatchLogger'

const onlineSound = new Audio('/connected.wav')
const offlineSound = new Audio('/disconnected.wav')

interface NetworkConnectivityProps {
  playConnectionChangeSound?: boolean
  reportAnalytics?: boolean
}

export function useNetworkConnectivity({
  playConnectionChangeSound = true,
  reportAnalytics = true,
}: NetworkConnectivityProps) {
  const [isOnline, setIsOnline] = useState(true)
  const { logger } = useCloudwatchLogger('useConnectivityAlert')
  const { track } = useAnalytics(AnalyticsNamespace.WEB_PHONE)

  useEffect(() => {
    const handleOnline = () => {
      logger?.info('network connected')
      setIsOnline(true)
      if (reportAnalytics) track(WebPhoneAnalyticsEvents.NetworkConnected)
      if (playConnectionChangeSound) onlineSound.play()
    }

    const handleOffline = () => {
      logger?.warn('network disconnected')
      setIsOnline(false)
      if (reportAnalytics) track(WebPhoneAnalyticsEvents.NetworkDisconnected)
      if (playConnectionChangeSound) offlineSound.play()
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [playConnectionChangeSound])

  return isOnline
}
